import { render, staticRenderFns } from "./composibleApiTest.vue?vue&type=template&id=b9e03d4c&"
import script from "./composibleApiTest.vue?vue&type=script&setup=true&lang=ts&"
export * from "./composibleApiTest.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports